import React, { useState, useEffect, useLayoutEffect, useMemo, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Skeleton } from '@mui/material'; // Add this import for skeleton
import './style.css';
import { getWidgetSettings } from '../../../store/features/getWidgetSettings';
import { saveWidgetSettings } from '../../../store/features/saveWidgetSettings';
import GeneralSettings from './GeneralSettings';
import AdvanceSettings from '../../dashboardcomponents/Settings/AdvanceSettings';
import InstallChatWidget from '../../dashboardcomponents/Settings/InstallChatWidget';
import PreviewOne from '../../dashboardcomponents/Settings/PreviewOne';
import PreviewTwo from '../../dashboardcomponents/Settings/PreviewTwo';
import PreviewThree from '../../dashboardcomponents/Settings/PreviewThree';
import Loader from '../../../assets/Loader';
import {
  getWidgetSettingsWarmCache,
  setWidgetSettingsWarmCache,
} from '../../../utils/widgetSettingsWarmCache';

function WidgetSettings() {
  const [showWelcomeScreen, setShowWelcomeScreen] = useState(true);
  const [startChatAlways, setStartChatAlways] = useState(true);
  const [nameRequired, setNameRequired] = useState(false);
  const [emailRequired, setEmailRequired] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);
  const [widgetSelectedTab, setWidgetSelectedTab] = useState('Web');
  const [currentPreview, setCurrentPreview] = useState('PreviewTwo');
  const [isLoading, setIsLoading] = useState(true);

  // PreviewOne
  const [logo, setLogo] = useState(null);
  const [logoFile, setLogoFile] = useState(null);
  const [welcomeText, setWelcomeText] = useState("Hello Guest");
  const [sideSpace, setSideSpace] = useState("0");
  const [bottomSpace, setBottomSpace] = useState("0");
  const [color, setColor] = useState("");
  const [gradientOne, setGradientOne] = useState("#0059E1");
  const [gradientTwo, setGradientTwo] = useState("#1EB9EB");
  const [alignment, setAlignment] = useState("Right");
  const [language, setLanguage] = useState("English");

  // PreviewTwo
  const [preChat, setPreChat] = useState(true);
  const [guestMode, setGuestMode] = useState(true);

  // PreviewThree
  const [showAgentPhoto, setShowAgentPhoto] = useState(true);
  const [bubble, setBubble] = useState(true);
  const [showLogo, setShowLogo] = useState(true);
  const [welcomeMessage, setWelcomeMessage] = useState("Hello. How may I help you?");
  const [placeholderText, setPlaceholderText] = useState("Type your message ...");
  const [offlineInfo, setOfflineInfo] = useState("Our team is currently offline. Please create a ticket.");
  const [sound, setSound] = useState(true);
  const [label, setLabel] = useState(true);
  const [offlineTitle, setOfflineTitle] = useState("Create a ticket");

  // Track changes
  const [hasChanges, setHasChanges] = useState(false);

  // Reference for storing initial settings
  const initialSettingsRef = useRef({
    logo: null,
    welcomeText: "Hello",
    color: "#148DFD",
    gradientOne: "#0059E1",
    gradientTwo: "#1EB9EB",
    alignment: "Right",
    language: "English",
    preChat: true,
    guestMode: true,
    showAgentPhoto: true,
    bubble: true,
    showLogo: true,
    welcomeMessage: "Hello. How may I help you?",
    sideSpace: "15",
    bottomSpace: "15",
    placeholderText: "Type your message ...",
    offlineTitle: "Create a ticket",
    offlineInfo: "Our team is currently offline. Please create a ticket.",
    sound: true,
    label: true,
    showWelcomeScreen: true,
    startChatAlways: true,
    nameRequired: true,
    emailRequired: true,

  });

  const dispatch = useDispatch();
  const userData = useSelector((state) => state.loginToken);
  const businessId = userData?.response?.user?.business_id;

  const handleSaveSettings = async () => {
    const data = {
      business_id: userData?.response?.user?.business_id,
      welcome_text: welcomeText,
      theme_color: color,
      gradient_one: gradientOne,
      gradient_two: gradientTwo,
      logo: logoFile,
      alignment: alignment,
      lang: language,
      pre_chat_form: preChat,
      allow_guest: guestMode,
      welcome_message: welcomeMessage,
      side_space: sideSpace,
      bottom_space: bottomSpace,
      message_placeholder: placeholderText,
      offline_title: offlineTitle,
      offline_info: offlineInfo,
      show_logo: showLogo,
      show_agent_photo: showAgentPhoto,
      bubble: bubble,
      sound: sound,
      label: label,
      show_welcome_screen: showWelcomeScreen,
      start_chat_always: startChatAlways,
      name_required: nameRequired,
      email_required: emailRequired,
    };
    const formData = new FormData();
    formData.append('business_id', data.business_id);
    formData.append('welcome_text', data.welcome_text);
    formData.append('theme_color', data.theme_color);
    formData.append('gradient_one', data.gradient_one);
    formData.append('gradient_two', data.gradient_two);
    if (logoFile) {
      formData.append('logo', data.logo);
    }
    formData.append('alignment', data.alignment);
    formData.append('lang', data.lang);
    formData.append('pre_chat_form', data.pre_chat_form);
    formData.append('allow_guest', data.allow_guest);
    formData.append('welcome_message', data.welcome_message);
    formData.append('side_space', data.side_space);
    formData.append('bottom_space', data.bottom_space);
    formData.append('message_placeholder', data.message_placeholder);
    formData.append('offline_title', data.offline_title);
    formData.append('offline_info', data.offline_info);
    formData.append('show_logo', data.show_logo);
    formData.append('show_agent_photo', data.show_agent_photo);
    formData.append('bubble', data.bubble);
    formData.append('sound', data.sound);
    formData.append('white_label', data.label);
    formData.append('show_welcome_screen', data.show_welcome_screen);
    formData.append('start_chat_always', data.start_chat_always);
    formData.append('name_required', data.name_required);
    formData.append('email_required', data.email_required);

    const listCoUserList = dispatch(
      saveWidgetSettings(formData),
    );
    listCoUserList
      .then(async (data) => {
        if (!data.payload) {
          toast.error('Some Error Occured. Please try again later.', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
        } else if (data?.payload?.success) {
          console.log('data----------------------', data.payload.data);
          getSettings({ background: true });
          // setResponseText('');
        } else {
          toast.error('Some Error Occured. Please try again later.', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
        }
      })
      .catch(async (error) => {
        toast.error(error, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        });
      });
  }

  const applySettingsFromPayload = useCallback((settings) => {
    if (!settings) return;
    setLogo((prev) => settings.logo || prev);
    setWelcomeText((prev) => settings.welcome_text || prev);
    setColor((prev) => settings.theme_color || prev);
    setGradientOne((prev) => settings.gradient_one || prev);
    setGradientTwo((prev) => settings.gradient_two || prev);
    setAlignment((prev) => settings.alignment || prev);
    setLanguage((prev) => settings.lang || prev);
    setPreChat((prev) => settings.pre_chat_form ?? prev);
    setGuestMode((prev) => settings.allow_guest ?? prev);
    setWelcomeMessage((prev) => settings.welcome_message || prev);
    setSideSpace((prev) => settings.side_space || prev);
    setBottomSpace((prev) => settings.bottom_space || prev);
    setPlaceholderText((prev) => settings.message_placeholder || prev);
    setOfflineInfo((prev) => settings.offline_info || prev);
    setOfflineTitle((prev) => settings.offline_title || prev);
    setShowAgentPhoto((prev) => settings.show_agent_photo ?? prev);
    setBubble((prev) => settings.bubble ?? prev);
    setShowLogo((prev) => settings.show_logo ?? prev);
    setSound((prev) => settings.sound ?? prev);
    setLabel((prev) => settings.white_label ?? prev);
    setShowWelcomeScreen((prev) => settings.show_welcome_screen ?? prev);
    setStartChatAlways((prev) => settings.start_chat_always ?? prev);
    setNameRequired((prev) => settings.name_required ?? prev);
    setEmailRequired((prev) => settings.email_required ?? prev);

    initialSettingsRef.current = {
      logo: settings.logo || initialSettingsRef.current.logo,
      welcomeText: settings.welcome_text || initialSettingsRef.current.welcomeText,
      color: settings.theme_color || initialSettingsRef.current.color,
      gradientOne: settings.gradient_one || initialSettingsRef.current.gradientOne,
      gradientTwo: settings.gradient_two || initialSettingsRef.current.gradientTwo,
      alignment: settings.alignment || initialSettingsRef.current.alignment,
      language: settings.lang || initialSettingsRef.current.language,
      preChat: settings.pre_chat_form ?? initialSettingsRef.current.preChat,
      guestMode: settings.allow_guest ?? initialSettingsRef.current.guestMode,
      welcomeMessage: settings.welcome_message || initialSettingsRef.current.welcomeMessage,
      sideSpace: settings.side_space || initialSettingsRef.current.sideSpace,
      bottomSpace: settings.bottom_space || initialSettingsRef.current.bottomSpace,
      placeholderText: settings.message_placeholder || initialSettingsRef.current.placeholderText,
      offlineInfo: settings.offline_info || initialSettingsRef.current.offlineInfo,
      offlineTitle: settings.offline_title || initialSettingsRef.current.offlineTitle,
      showAgentPhoto: settings.show_agent_photo ?? initialSettingsRef.current.showAgentPhoto,
      bubble: settings.bubble ?? initialSettingsRef.current.bubble,
      showLogo: settings.show_logo ?? initialSettingsRef.current.showLogo,
      sound: settings.sound ?? initialSettingsRef.current.sound,
      label: settings.white_label ?? initialSettingsRef.current.label,
      showWelcomeScreen: settings.show_welcome_screen ?? initialSettingsRef.current.showWelcomeScreen,
      startChatAlways: settings.start_chat_always ?? initialSettingsRef.current.startChatAlways,
      nameRequired: settings.name_required ?? initialSettingsRef.current.nameRequired,
      emailRequired: settings.email_required ?? initialSettingsRef.current.emailRequired,
    };
  }, []);

  const getSettings = useCallback(
    async (options = {}) => {
      const { background = false } = options;
      if (!businessId) return;
      if (!background) setIsLoading(true);
      const listCoUserList = dispatch(getWidgetSettings({ id: businessId }));
      listCoUserList
        .then(async (data) => {
          if (!data.payload) {
            toast.error('Some Error Occured. Please try again later.', {
              position: 'top-right',
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: 'light',
            });
          } else if (data?.payload?.success) {
            const settings = data.payload.data;
            applySettingsFromPayload(settings);
            setWidgetSettingsWarmCache({
              businessId,
              data: settings,
              hasFetched: true,
            });
          } else {
            toast.error('Some Error Occured. Please try again later.', {
              position: 'top-right',
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: 'light',
            });
          }
        })
        .catch(async (error) => {
          toast.error(error, {
            position: 'top-right',
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
        })
        .finally(() => {
          setIsLoading(false);
        });
    },
    [businessId, dispatch, applySettingsFromPayload],
  );

  useLayoutEffect(() => {
    if (!businessId) return;
    const wc = getWidgetSettingsWarmCache();
    const warm =
      wc.hasFetched &&
      String(wc.businessId) === String(businessId) &&
      wc.data;
    if (warm) {
      applySettingsFromPayload(wc.data);
      setIsLoading(false);
      void getSettings({ background: true });
    } else {
      void getSettings({ background: false });
    }
  }, [businessId, getSettings, applySettingsFromPayload]);

  // Check for unsaved changes
  useEffect(() => {
    const isChanged =
      logo !== initialSettingsRef.current.logo ||
      welcomeText !== initialSettingsRef.current.welcomeText ||
      color !== initialSettingsRef.current.color ||
      gradientOne !== initialSettingsRef.current.gradientOne ||
      gradientTwo !== initialSettingsRef.current.gradientTwo ||
      alignment !== initialSettingsRef.current.alignment ||
      language !== initialSettingsRef.current.language ||
      preChat !== initialSettingsRef.current.preChat ||
      guestMode !== initialSettingsRef.current.guestMode ||
      showAgentPhoto !== initialSettingsRef.current.showAgentPhoto ||
      bubble !== initialSettingsRef.current.bubble ||
      showLogo !== initialSettingsRef.current.showLogo ||
      welcomeMessage !== initialSettingsRef.current.welcomeMessage ||
      sideSpace !== initialSettingsRef.current.sideSpace ||
      bottomSpace !== initialSettingsRef.current.bottomSpace ||
      placeholderText !== initialSettingsRef.current.placeholderText ||
      offlineInfo !== initialSettingsRef.current.offlineInfo ||
      offlineTitle !== initialSettingsRef.current.offlineTitle ||
      sound !== initialSettingsRef.current.sound ||
      label !== initialSettingsRef.current.label ||
      showWelcomeScreen !== initialSettingsRef.current.showWelcomeScreen ||
      startChatAlways !== initialSettingsRef.current.startChatAlways ||
      nameRequired !== initialSettingsRef.current.nameRequired ||
      emailRequired !== initialSettingsRef.current.emailRequired;

    setHasChanges(isChanged);
  }, [logo, welcomeText, color, gradientOne, gradientTwo, alignment, language, preChat, guestMode, showAgentPhoto, bubble, showLogo, welcomeMessage, sideSpace,
    bottomSpace, placeholderText, offlineInfo, offlineTitle, sound, label, nameRequired, emailRequired, showWelcomeScreen, startChatAlways]);


  const handleCancel = () => {
    setLogo(initialSettingsRef.current.logo);
    setWelcomeText(initialSettingsRef.current.welcomeText);
    setColor(initialSettingsRef.current.color);
    setGradientOne(initialSettingsRef.current.gradientOne);
    setGradientTwo(initialSettingsRef.current.gradientTwo);
    setAlignment(initialSettingsRef.current.alignment);
    setLanguage(initialSettingsRef.current.language);
    setPreChat(initialSettingsRef.current.preChat);
    setGuestMode(initialSettingsRef.current.guestMode);
    setShowAgentPhoto(initialSettingsRef.current.showAgentPhoto);
    setBubble(initialSettingsRef.current.bubble);
    setShowLogo(initialSettingsRef.current.showLogo);
    setWelcomeMessage(initialSettingsRef.current.welcomeMessage);
    setSideSpace(initialSettingsRef.current.sideSpace);
    setBottomSpace(initialSettingsRef.current.bottomSpace);
    setPlaceholderText(initialSettingsRef.current.placeholderText);
    setOfflineInfo(initialSettingsRef.current.offlineInfo);
    setOfflineTitle(initialSettingsRef.current.offlineTitle);
    setSound(initialSettingsRef.current.sound);
    setLabel(initialSettingsRef.current.label);
    setShowWelcomeScreen(initialSettingsRef.current.showWelcomeScreen);
    setStartChatAlways(initialSettingsRef.current.startChatAlways);
    setNameRequired(initialSettingsRef.current.nameRequired);
    setEmailRequired(initialSettingsRef.current.emailRequired);
    setHasChanges(false);
  };

  const handleSave = () => {
    handleSaveSettings();
    setHasChanges(false);
  };

  const handleShowWelcomeScreen = (event) => {
    setShowWelcomeScreen(event.target.checked);
  };

  const handleNameCheckboxChange = (event) => {
    setNameRequired(event.target.checked);
  };

  const handleEmailCheckboxChange = (event) => {
    setEmailRequired(event.target.checked);
  };

  // Wrapper functions for GeneralSettings
  const handleLanguageChange = (newLanguage) => {
    setLanguage(newLanguage);
    setWelcomeText(newLanguage === "English" ? "Hello, Guest" : "Bonjour, Invité");
    setPlaceholderText(newLanguage === "English" ? "Type your message ..." : "Tapez votre message...");

  };

  const handleLogoChange = (previewUrl, file) => {
    setLogo(previewUrl);
    setLogoFile(file);
  };

  const handleWelcomeTextChange = (newText) => {
    setWelcomeText(newText);
  };

  const handleColorChange = (newColor) => {
    setColor(newColor);
  };

  const handleGradientOneChange = (newColor) => {
    setGradientOne(newColor);
  };

  const handleGradientTwoChange = (newColor) => {
    setGradientTwo(newColor);
  };

  const handleAlignmentChange = (newAlignment) => {
    setAlignment(newAlignment);
  };
  //


  // Wrapper functions for AdvanceSettings
  const handlePreChatChange = (value) => {
    setPreChat(value);
  };

  const handleGuestModeChange = (value) => {
    setGuestMode(value);
  };

  const handleWelcomeMessageChange = (value) => {
    setWelcomeMessage(value);
  };

  const handleSideSpace = (value) => {
    setSideSpace(value);
  };

  const handleBottomSpace = (value) => {
    setBottomSpace(value);
  };

  const handlePlaceholderTextChange = (value) => {
    setPlaceholderText(value);
  };

  const handleOfflineInfoChange = (value) => {
    setOfflineInfo(value);
  };

  const handleAgentPhotoChange = (event) => {
    setShowAgentPhoto(event.target.checked);
  };

  const handleBubble = (value) => {
    setBubble(value);
  };

  const handleStartChatAlways = (value) => {
    setStartChatAlways(value);
  };

  const handleShowLogoChange = (event) => {
    setShowLogo(event.target.checked);
  };

  const handleSoundChange = (event) => {
    setSound(event.target.checked);
  };

  const handleLabelChange = (event) => {
    setLabel(event.target.checked);
  };
  //

  const handleOfflineTitleChange = (value) => {
    setOfflineTitle(value);
  };

  const handleScroll = (event) => {
    const { scrollTop, scrollHeight, clientHeight } = event.target;
    const scrollRatio = scrollTop / (scrollHeight - clientHeight);

    if (scrollRatio > 0.55) {
      setCurrentPreview('PreviewThree');
    } else {
      setCurrentPreview('PreviewTwo');
    }
  };

  const registrationUIRender = useMemo(
    () => (
      <>
        {selectedTab === 0 ? (
          <GeneralSettings
            color={color}
            setColor={setColor}
            gradientOne={gradientOne}
            gradientTwo={gradientTwo}
            welcomeText={welcomeText}
            alignment={alignment}
            language={language}
            logo={logo}
            bubble={bubble}
            onBubbleChange={handleBubble}
            sideSpace={sideSpace}
            onSideSpaceChange={handleSideSpace}
            bottomSpace={bottomSpace}
            onBottomSpaceChange={handleBottomSpace}
            onLogoChange={handleLogoChange}
            onWelcomeTextChange={handleWelcomeTextChange}
            onLanguageChange={handleLanguageChange}
            onColorChange={handleColorChange}
            onGradientOneChange={handleGradientOneChange}
            onGradientTwoChange={handleGradientTwoChange}
            onAlignmentChange={handleAlignmentChange}
          />
        ) : selectedTab === 1 ? (
          <AdvanceSettings
            preChat={preChat}
            guestMode={guestMode}

            welcomeMessage={welcomeMessage}
            placeholderText={placeholderText}
            offlineInfo={offlineInfo}
            offlineTitle={offlineTitle}
            onPreChatChange={handlePreChatChange}
            onGuestModeChange={handleGuestModeChange}

            showLogo={showLogo}
            showAgentPhoto={showAgentPhoto}
            sound={sound}
            label={label}

            onWelcomeMessageChange={handleWelcomeMessageChange}
            onPlaceholderTextChange={handlePlaceholderTextChange}
            onOfflineInfoChange={handleOfflineInfoChange}
            onOfflineTitleChange={handleOfflineTitleChange}


            onAgentPhotoChange={handleAgentPhotoChange}
            onShowLogoChange={handleShowLogoChange}
            onSoundChange={handleSoundChange}
            onLabelChange={handleLabelChange}

            onLogoChange={handleLogoChange}

            showWelcomeScreen={showWelcomeScreen}
            onShowWelcomeScreenChange={handleShowWelcomeScreen}
            startChatAlways={startChatAlways}
            onStartChatAlwaysChange={handleStartChatAlways}
            nameRequired={nameRequired}
            onNameCheckboxChange={handleNameCheckboxChange}
            emailRequired={emailRequired}
            onEmailCheckboxChange={handleEmailCheckboxChange}
          />
        ) : selectedTab === 2 ? (
          <InstallChatWidget />
        ) : null}
      </>
    ),
    [selectedTab, welcomeText, color, gradientOne, gradientTwo, alignment, language, preChat, guestMode, welcomeMessage, sideSpace, bottomSpace, placeholderText, offlineInfo, offlineTitle, showAgentPhoto, bubble, showLogo, sound, label, logo, nameRequired, emailRequired, showWelcomeScreen, startChatAlways],
  );

  const currentLanguage = useSelector(
    (state) => state.language.currentLanguage,
  );

  const t = useSelector(
    (state) => state.language.translations[currentLanguage],
  );


  const handleRowClick = (id) => {
    setActiveRowId(id);
  };

  const handleTabChange = (newValue) => {
    setSelectedTab(newValue);
  };

  // Skeleton Loader Component (UI-matched)
  const SkeletonLoader = () => (
    <>
      {/* Header */}
      <div className="TicketManagment-Container001">
        <Skeleton variant="text" sx={{ fontSize: '24px', width: '150px', height: '32px' }} />
      </div>

      {/* Main Flex Container */}
      <div style={{ display: 'flex', gap: '16px', overflowY: 'scroll', padding: '24px 24px' }}>
        {/* Left Side: Main Widget Settings */}
        <div className="main-widget-settings">
          {/* Tabs Skeleton */}
          <div className="widget-settings-tabs-container">
            {[0, 1, 2].map((index) => (
              <Skeleton key={index} variant="rounded" sx={{ height: '40px', width: '150px', marginRight: '8px' }} />
            ))}
          </div>

          {/* Content Skeleton - Mimic sections based on tabs */}
          <div style={{ padding: '20px 0' }}>
            {/* Info Section Skeleton */}
            <Skeleton variant="text" sx={{ fontSize: '18px', width: '80px', height: '24px', marginBottom: '16px' }} />
            {/* Logo Upload Skeleton */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '24px' }}>
              <Skeleton variant="circular" width={56} height={56} />
              <div style={{ flex: 1 }}>
                <Skeleton variant="text" sx={{ fontSize: '14px', width: '100px' }} />
                <Skeleton variant="text" sx={{ fontSize: '12px', width: '200px' }} />
              </div>
            </div>
            {/* Inputs Skeleton */}
            <div style={{ marginBottom: '16px' }}>
              <Skeleton variant="text" sx={{ fontSize: '14px', width: '120px', marginBottom: '8px' }} />
              <Skeleton variant="rounded" sx={{ height: '40px' }} />
            </div>
            <div style={{ marginBottom: '24px' }}>
              <Skeleton variant="text" sx={{ fontSize: '14px', width: '120px', marginBottom: '8px' }} />
              <Skeleton variant="rounded" sx={{ height: '40px' }} />
            </div>

            {/* Appearance Section Skeleton */}
            <Skeleton variant="text" sx={{ fontSize: '18px', width: '100px', height: '24px', marginBottom: '16px' }} />
            <div style={{ display: 'flex', gap: '16px', marginBottom: '24px' }}>
              <div style={{ flex: 1 }}>
                <Skeleton variant="text" sx={{ fontSize: '14px', width: '120px', marginBottom: '8px' }} />
                <div style={{ display: 'flex', gap: '8px' }}>
                  {[1, 2].map((i) => <Skeleton key={i} variant="rounded" sx={{ height: '40px', width: '80px' }} />)}
                </div>
              </div>
              <div style={{ flex: 1 }}>
                <Skeleton variant="text" sx={{ fontSize: '14px', width: '120px', marginBottom: '8px' }} />
                <div style={{ display: 'flex', gap: '8px' }}>
                  {[1, 2].map((i) => <Skeleton key={i} variant="rounded" sx={{ height: '40px', width: '80px' }} />)}
                </div>
              </div>
            </div>
            {/* Color Options Skeleton */}
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: '16px', marginBottom: '24px' }}>
              <div style={{ flex: 1 }}>
                <Skeleton variant="text" sx={{ fontSize: '14px', width: '100px' }} />
                <div style={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
                  {[1, 2, 3, 4].map((i) => <Skeleton key={i} variant="circular" width={32} height={32} />)}
                </div>
              </div>
              <Skeleton variant="rounded" sx={{ height: '120px', flex: 1 }} />
            </div>

            {/* Visibility Section Skeleton */}
            <Skeleton variant="text" sx={{ fontSize: '18px', width: '100px', height: '24px', marginBottom: '16px' }} />
            <div style={{ display: 'flex', gap: '16px' }}>
              <div style={{ flex: 1 }}>
                <Skeleton variant="text" sx={{ fontSize: '14px', width: '80px', marginBottom: '8px' }} />
                <Skeleton variant="rounded" sx={{ height: '40px' }} />
              </div>
              <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '16px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <Skeleton variant="rounded" sx={{ height: '40px', width: '80px' }} />
                  <Skeleton variant="text" sx={{ fontSize: '12px', width: '30px' }} />
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <Skeleton variant="rounded" sx={{ height: '40px', width: '80px' }} />
                  <Skeleton variant="text" sx={{ fontSize: '12px', width: '30px' }} />
                </div>
              </div>
            </div>

            {/* Language Section Skeleton */}
            <Skeleton variant="text" sx={{ fontSize: '18px', width: '120px', height: '24px', marginBottom: '16px' }} />
            <Skeleton variant="rounded" sx={{ height: '40px', width: '200px' }} />
          </div>
        </div>

        {/* Right Side: Sidebar Widget Settings */}
        <div className="sidebar-widget-settings">
          {/* Sidebar Tabs Skeleton */}
          <div className="sidebar-widget-settings-tab" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '16px' }}>
            <div style={{ display: 'flex', gap: '8px' }}>
              {['Web', 'Android', 'iOS'].map((tab) => (
                <Skeleton key={tab} variant="rounded" sx={{ height: '32px', width: '60px' }} />
              ))}
            </div>
            <Skeleton variant="text" sx={{ fontSize: '14px', width: '80px', height: '20px' }} />
          </div>

          {/* Preview Skeleton - Generic rounded block for previews */}
          <Skeleton variant="rounded" sx={{ height: '500px', width: '100%' }} />
        </div>
      </div>

      {/* Footer Banner Skeleton (if changes, but for loading, optional - show faintly) */}
      <div style={{
        position: 'fixed',
        bottom: 0,
        right: 0,
        left: 0,
        width: '100%',
        padding: '1.25rem',
        display: 'flex',
        gap: '32px',
        justifyContent: 'center',
        background: '#fff',
      }}>
        <Skeleton variant="rounded" sx={{ height: '40px', width: '100px' }} />
        <Skeleton variant="rounded" sx={{ height: '40px', width: '150px' }} />
      </div>
    </>
  );

  if (isLoading) {
    return <SkeletonLoader />;
  }

  return (
    <>
      <div className="TicketManagment-Container001">

        <p style={{ lineHeight: '24px' }} className="Ticket-text">Chat Widget</p>

      </div>
      <div style={{ display: 'flex', gap: '16px', overflowY: 'scroll', padding: '24px 24px' }} onScroll={handleScroll}>
        <div className="main-widget-settings">

          <div className="widget-settings-tabs-container">
            <button
              className={`custom-tab ${selectedTab === 0 ? 'selected' : ''}`}
              onClick={() => handleTabChange(0)}
            >
              General Settings
            </button>
            <button
              className={`custom-tab ${selectedTab === 1 ? 'selected' : ''}`}
              onClick={() => handleTabChange(1)}
            >
              Advance Settings
            </button>
            <button
              className={`custom-tab ${selectedTab === 2 ? 'selected' : ''}`}
              onClick={() => handleTabChange(2)}
            >
              Install Chat Widget
            </button>
          </div>

          {registrationUIRender}

        </div>

        <div className="sidebar-widget-settings">

          <div className="sidebar-widget-settings-tab" style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div>
              <button
                className={`custom-tab custom-tab-sidebar ${widgetSelectedTab === 'Web' ? 'selected' : ''}`}
                onClick={() => setWidgetSelectedTab('Web')}
              >
                Web
              </button>
              <button
                className={`custom-tab custom-tab-sidebar ${widgetSelectedTab === 'Android' ? 'selected' : ''}`}
                onClick={() => setWidgetSelectedTab('Android')}
              >
                Android
              </button>
              <button
                className={`custom-tab custom-tab-sidebar ${widgetSelectedTab === 'iOS' ? 'selected' : ''}`}
                onClick={() => setWidgetSelectedTab('iOS')}
              >
                ios
              </button>
            </div>
            <div style={{ marginTop: "5px" }}>
              <span className="live-view-link">Live view</span>
            </div>
          </div>

          {selectedTab === 0 ? (
            <PreviewOne
              logo={logo}
              bubble={bubble}
              welcomeText={welcomeText}
              placeholderText={placeholderText}
              color={color}
              gradientOne={gradientOne}
              gradientTwo={gradientTwo}
              alignment={alignment}
            />
          ) : selectedTab === 1 ? (
            currentPreview === 'PreviewTwo' ?
              <PreviewTwo
                welcomeText={welcomeText}
                color={color}
                gradientOne={gradientOne}
                gradientTwo={gradientTwo}
                alignment={alignment}
                preChat={preChat}
                guestMode={guestMode}
                bubble={bubble}
                nameRequired={nameRequired}
                emailRequired={emailRequired}
              /> :
              <PreviewThree
                color={color}
                gradientOne={gradientOne}
                gradientTwo={gradientTwo}
                alignment={alignment}
                showAgentPhoto={showAgentPhoto}
                showLogo={showLogo}
                welcomeMessage={welcomeMessage}
                placeholderText={placeholderText}
                bubble={bubble}
              />
          ) : (
            <PreviewOne
              logo={logo}
              welcomeText={welcomeText}
              placeholderText={placeholderText}
              color={color}
              gradientOne={gradientOne}
              gradientTwo={gradientTwo}
              alignment={alignment}
              bubble={bubble}
            />
          )}
        </div>

        {/* Footer banner */}
        {hasChanges && (
          <div style={{
            position: 'fixed',
            bottom: 0,
            right: 0,
            left: 0,
            width: '100%',
            padding: '1.25rem',
            display: 'flex',
            gap: '32px',
            justifyContent: 'center',
            background: '#fff',
          }}>
            <button onClick={handleCancel} className=" banner-cancel-button">Cancel</button>
            <button onClick={handleSave} className="settings-tab-button banner-save-button">Save Changes</button>
          </div>
        )}

      </div>
    </>
  );
}

export default WidgetSettings;